<template>
  <div>
    <div class="father">
      <div>
        <h1>Main heading</h1>
        <h2>Sub heading</h2>
      </div>
      <div>
        <article>
          <img src="../../../static/img/一站式安全服务1.jpg" />
          <h2></h2>
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>企业安全防卫服务</h3>
              </div>
            </div>
            <p>
              面向政府机关、金融机构、企事业单位、独资合资企业等其他场所提供门卫安全、责任区域安全巡逻、防盗、防火检查、其他应
              客户要求的安全防范。做到高效、高质、高标准，为客户提供专业安防服务。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务2.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>大型活动安保服务</h3>
              </div>
            </div>
            <p>
              配有专业的勤务指挥和保障车辆，执勤防护装备精良，可为各类文艺演出、艺术品拍卖、体育赛事、会
              议展览等大型活动提供现场安保服务。维护现场秩序，保护场地安全。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务3.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>随身护卫服务</h3>
              </div>
            </div>
            <p>
              主要为商界高层、文艺界、体育界以及其他社会知名人士提供高级安保服务，提供全程化安全
              护卫方案，通过风险预警、贴身护卫、定点守护等方式为客户人身安全提供有力保障。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务4.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>安全检查服务</h3>
              </div>
            </div>
            <p>
              宏邦拥有一支专业的安检团队，经过严格的安检职业技能培训，并配备专业全套的安全检查设备。
              为各类大型活动群众性活动及公共交通行业提供专业的防暴力、防爆炸等安全检查服务。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务5.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>守护巡逻服务</h3>
              </div>
            </div>
            <p>
              为各大事企单位、商场、社区等提供安防巡逻服务，对特定区域进行巡视检查、警戒，联合相关部门以达到震慑不法分子、
              及时发现制止不法行为、消除安全隐患、防止危险事件发生等安防目的。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务6.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>设备运维服务</h3>
              </div>
            </div>
            <p>
              根据客户需求，基于以设备运维平台为核心载体的设
              备运维标准体系，为客户提供针对性的智慧、高效、
              专业的平台运维，实现设备全生命周期一体化优质服务，提升设备可使用价值。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务7.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>安保设备租售服务</h3>
              </div>
            </div>
            <p>
              为大型活动、赛事、展会等活动提供安保设备临时
              出租或出售，类目齐全，质量保障。设备全部通过 欧盟 CE 认证和
              ISO9001 质量管理体系认证，符合 ISO14001 环境管理体系要求。
            </p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/一站式安全服务8.jpg" />
          <div class="content_div">
            <div class="item_div">
              <img src="../../../static/img/安保banner箭头.png" />
              <div>
                <h3>专业保安培训服务</h3>
              </div>
            </div>
            <p>
              经过多年的积累和发展，宏邦在保安培训方面拥有了丰富的经验，宏邦拥有专业的培训机构并与不同区域不同方位的多家培训学校达成合作协议，并为多家保安服务企业提供培训支持。以最专业的态度提供最实际的教育资源。
            </p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.father {
  width: 100%;
  height: 65rem;
  margin: 5rem auto;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: var(--textBlue60);
    position: absolute;
    top: 0;

    h3 {
      margin: 0;
      font-size: 3rem;
      font-family: bold;
    }

    p {
      margin: 0 5rem 0 5rem;
      width: auto;
      font-size: 1.8rem;
      line-height: 3rem;
      font-family: light;
    }

    .first_p {
      margin: 5rem 5rem 0 5rem;
    }

    .item_div {
      margin: 5rem 0 5rem 5rem;
      display: flex;
      position: relative;
      width: fit-content;
      top: 0;
      background: transparent;
      align-items: center;

      img {
        width: 2.2rem;
        margin-right: 3rem;
      }
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 17%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 10%;
  }

  div + div article:hover {
    width: 50%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }

  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>